export default theme => ({
  blockContainer: {
    position: 'relative',
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      height: 'initial',
      width: '100%',
      minWidth: 'initial',
      padding: 0,
      backgroundImage: 'none !important',
      backgroundColor: theme.palette.orange.main,
      paddingBottom: theme.spacing(2),
    },
  },
  mainTitle: {
    zIndex: 2,
    position: 'absolute',
    top: '8%',
    left: '5%',
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      top: 0,
      left: 0,
      textAlign: 'center',
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  desc: {
    position: 'absolute',
    maxWidth: '30%',
    height: 'auto',
    top: '50%',
    left: '5%',
    padding: theme.spacing(4),
    color: theme.palette.blue.dark,
    backgroundColor: theme.palette.white.main,
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      top: 0,
      left: 0,
      width: 'initial',
      height: 'initial',
      padding: theme.spacing(4),
      margin: theme.spacing(2),
      maxWidth: '100%',
    },
  },
  articles: {
    position: 'absolute',
    width: '30%',
    top: 'calc(50% - 28px)',
    right: '5%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    transform: 'translateY(-50%)',
    backgroundColor: theme.palette.white.main,
    color: theme.palette.blue.dark,
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      top: 0,
      left: 0,
      width: 'initial',
      height: 'initial',
      margin: theme.spacing(2),
      marginBottom: 0,
      transform: 'none',
    },
  },
  article: {
    padding: theme.spacing(6),
    maxWidth: '80%',
    '&:first-child': {
      paddingBottom: theme.spacing(1),
    },
    '&:last-child': {
      paddingTop: theme.spacing(1),
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: 'initial',
    },
  },
});
